import React from 'react';
import { Button } from '@material-ui/core';

/** Props for Styled Button */
export interface StyledButtonProps {
  buttonText: string;
  buttonStyle: string;
  disabled?: boolean;
  onClickHandler: () => void | Promise<void>;
}

/** Component for Button variant outlined, styled as per template settings */
export const StyledButton: React.FC<StyledButtonProps> = (props: StyledButtonProps): JSX.Element => {
  const { buttonText, buttonStyle } = props;

  return (
    <Button
      type={'submit'}
      disabled={props.disabled}
      aria-hidden={props.disabled}
      aria-disabled="false"
      variant="outlined"
      color={buttonStyle === 'STYLE_1' ? 'primary' : 'secondary'}
      onClick={props.onClickHandler}>
      <div>{buttonText}</div>
    </Button>
  );
};
